import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { ScenarioField } from "../types/field";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/data-input/field`;

export interface AddFieldRequest {
  field: ScenarioField;
  scenarioId: string;
}

export interface AddFieldResponse {
  fields: ScenarioField[];
}

const addField = async (request: AddFieldRequest): Promise<AddFieldResponse> => {
  const { field } = request;
  const response = await axios.post<AddFieldResponse>(API_URL, {
    // Send the full field so the user-facing display name (including any
    // bracketed context qualifier) is persisted and survives reload, rather
    // than only the backend property key.
    field: {
      field: field.field,
      name: field.name,
      product: field.product ?? null,
      unit: field.unit ?? null,
      syncField: field.syncField ?? null
    },
    scenarioId: request.scenarioId
  });

  return response.data;
};

export const useAddField = () => {
  const queryClient = useQueryClient();
  return useMutation<AddFieldResponse, AxiosError, AddFieldRequest>(addField, {
    onSuccess: () => {
      queryClient.invalidateQueries(["scenarioFields"]);
    }
  });
};
